import { render, staticRenderFns } from "./CompanyFavicon.vue?vue&type=template&id=2d3f7c92&scoped=true&"
import script from "./CompanyFavicon.vue?vue&type=script&lang=js&"
export * from "./CompanyFavicon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3f7c92",
  null
  
)

export default component.exports